var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng, } from 'react-google-places-autocomplete';
import Label from '../Label';
import Instruction from '../Instruction';
import SubInstruction from '../SubInstruction';
import classNames from 'classnames';
import { MapPin } from 'react-feather';
import Error from '../Error';
import { useState } from 'react';
import { useController } from 'react-hook-form';
var classes = {
    inputGroup: {
        base: 'flex items-center w-full rounded-md border border-gray-300 px-4 py-[14px] bg-white text-base transition-colors focus:border-2 focus:border-brand-dark',
        error: 'border-alert-danger focus:border-alert-danger',
    },
    input: 'flex-1 bg-white focus:outline-none placeholder-gray-500',
};
var Location = function (_a) {
    var _b;
    var label = _a.label, name = _a.name, control = _a.control, defaultValue = _a.defaultValue, _c = _a.required, required = _c === void 0 ? false : _c, instructions = _a.instructions, subInstructions = _a.subInstructions, placeholder = _a.placeholder, _d = _a.bigLabel, bigLabel = _d === void 0 ? false : _d, _e = _a.returnValue, returnValue = _e === void 0 ? 'object' : _e;
    var apiKey = window.GMAPS_API_KEY;
    var _f = useController({ name: name, control: control, defaultValue: defaultValue }), field = _f.field, fieldState = _f.fieldState;
    var _g = useState(false), showSubInstructions = _g[0], setShowSubInstructions = _g[1];
    var handleChange = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var results, latLng, mapObject, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (returnValue === 'address')
                        return [2 /*return*/, field.onChange(value)];
                    if (!value)
                        return [2 /*return*/, field.onChange(null)];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, geocodeByAddress(value.label)];
                case 2:
                    results = _a.sent();
                    return [4 /*yield*/, getLatLng(results[0])];
                case 3:
                    latLng = _a.sent();
                    mapObject = {
                        address: results[0].formatted_address,
                        lat: latLng.lat,
                        lng: latLng.lng,
                    };
                    field.onChange(mapObject);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    if (!apiKey)
        return null;
    return (<div className="flex w-full flex-col">
      {label && (<Label label={label} htmlFor={name} required={required} big={bigLabel} tooltip={!!subInstructions} onTooltipClick={function () { return setShowSubInstructions(true); }}/>)}
      {instructions && <Instruction instruction={instructions}/>}
      {subInstructions && (<SubInstruction instruction={subInstructions} open={showSubInstructions} close={function () { return setShowSubInstructions(false); }}/>)}
      <div className={classNames(classes.inputGroup.base, fieldState.error && classes.inputGroup.error)}>
        <GooglePlacesAutocomplete apiKey={apiKey} apiOptions={{ language: 'en' }} selectProps={{
            defaultValue: field.value && { label: (_b = field.value) === null || _b === void 0 ? void 0 : _b.address, value: field.value },
            onChange: function (value) { return handleChange(value); },
            name: name,
            placeholder: placeholder,
            isClearable: true,
            backspaceRemovesValue: true,
            className: classes.input,
            components: { DropdownIndicator: null, IndicatorSeparator: null },
            noOptionsMessage: function () { return placeholder; },
            loadingMessage: function () { return 'Chargement...'; },
            styles: {
                input: function (provided) { return (__assign(__assign({}, provided), { padding: 0, margin: 0, border: 'none' })); },
                valueContainer: function (provided) { return (__assign(__assign({}, provided), { padding: 0 })); },
                control: function (provided) { return (__assign(__assign({}, provided), { border: 0, minHeight: 'unset', boxShadow: 'none' })); },
                clearIndicator: function (provided) { return (__assign(__assign({}, provided), { paddingTop: 0, paddingBottom: 0 })); },
            },
        }}/>
        <MapPin className="text-brand-01" size={24}/>
      </div>
      {fieldState.error && <Error message={fieldState.error.message}/>}
    </div>);
};
export default Location;
